import { render, staticRenderFns } from "./bind-tip.vue?vue&type=template&id=598acc63&scoped=true&"
import script from "./bind-tip.vue?vue&type=script&lang=js&"
export * from "./bind-tip.vue?vue&type=script&lang=js&"
import style0 from "./bind-tip.vue?vue&type=style&index=0&id=598acc63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598acc63",
  null
  
)

export default component.exports